// extracted by mini-css-extract-plugin
export default {"frame":"PdfPreview_frame__UVNzt","pdf_page":"PdfPreview_pdf_page__uQl1o"};